import { Tooltip } from 'slab'
import { type PartnersPartnerAdmin, QuotingInvitedPartnerAdminRole } from 'utils/web_api.schemas'

interface PartnerAdminRowProps {
  partnerAdmin: PartnersPartnerAdmin
  role: QuotingInvitedPartnerAdminRole
}

export const PartnerAdminRow = ({ partnerAdmin, role }: PartnerAdminRowProps) => {
  const roleName = role === QuotingInvitedPartnerAdminRole.assignee
    ? 'Owner'
    : `${role.charAt(0).toUpperCase()}${role.slice(1)}`
  return (
    <div className='flex items-center justify-between p-2 hover:bg-gray-50 transition-colors'>
      <div className='flex flex-col gap-[2px] items-start'>
        <Tooltip content={`Roles: ${partnerAdmin.roles.join(', ')}`}>
          <p className='font-semibold'>{partnerAdmin.name}</p>
        </Tooltip>
        <p className='text-gray-600'>{partnerAdmin.email}</p>
      </div>
      <Tooltip content={`${partnerAdmin.email} has permission to ${role === QuotingInvitedPartnerAdminRole.viewer ? 'view' : 'edit'} the quote.`} withPortal={false}>
        <div className='text-gray-500 whitespace-nowrap'>
          {roleName}
        </div>
      </Tooltip>
    </div>
  )
}
